import InternalBar from "../TopLayout/InternalBar/InternalBar";
import React, {useEffect} from "react";
import './PageTopHeader.css';


function  PageTopHeader(props){
    let data = props?.data;

    useEffect(()=>{
    })
    return(
        <div className="page-top-header">
            <div className="header-flex">
                <div className="header-flex-icon">
                    <img src={data?.logo} alt="user" width={36} height={36}/> {data?.orgName}
                </div>
                <div className="header-flex-badge">
                    <img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/aug-15-points-group.png" alt="pointsgroup" width={34} />
                    <span>{data?.points}</span> Points
                </div>
            </div>
            <div className="header-progress">
                <div className="header-progress-caption">
                    <h2>{data?.earnedGmv}</h2>
                    <span> {data?.homeMileStone?.nextMilestone?.nextMilestone} </span>
                </div>
                <InternalBar height={12} width={data?.homeMileStone?.nextMilestone?.percentage}/>
            </div>
        </div>
    )
}

export default PageTopHeader;
